import { AppRoutes } from "../approutes.enum";


export enum LoginRoutes {
  NoAccess = "no-access",
  Login = AppRoutes.Login
};
